import React, { useEffect, useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getReleaseStats } from '../../api/reports'
import Pagination from '../Paginations'

const ReportsDetails = () => {
    const uid = localStorage.getItem('uid')
    const params = useParams()
    const [reports, setReports] = useState([])
    const reportsMonth = params.month.split('-')[1]
    const reportsYear = params.month.split('-')[0]

    const { data: releaseStatsData, isLoading, error } = useQuery({
        queryKey: ['releaseStats', uid, reportsYear, reportsMonth],
        queryFn: () => getReleaseStats(uid, reportsYear, reportsMonth),
        enabled: !!uid && !!reportsYear && !!reportsMonth,
    })

    useEffect(() => {
        if (releaseStatsData) {
            const flattenedReports = releaseStatsData.flatMap(release =>
                release.track_stats.map(track => ({
                    releaseTitle: release.title,
                    upc: release.upc,
                    trackTitle: track.title,
                    isrc: track.isrc,
                    streams: track.streams,
                    netEarnings: track.revenue,
                    grossEarnings: track.gross,
                    share: track.share,
                }))
            )
            setReports(flattenedReports)
        } else {
            setReports([])
        }
    }, [releaseStatsData])

    /////////// PAGINATION ///////////
    const itemsPerPage = 50
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        setCurrentPage(1)
    }, [reports])

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = reports.slice(indexOfFirstItem, indexOfLastItem)

    const totalPages = Math.ceil(reports.length / itemsPerPage)

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    if (isLoading) {
        return <div className='dash-section'><p>Loading reports...</p></div>
    }

    if (error) {
        return <div className='dash-section'><p>Error loading reports: {error.message}</p></div>
    }

    return (
        <div className='dash-section'>
            <h1 className='dash-title'>Reports</h1>
            <div className="row">
                <div className="col-12 mt-4">
                    <div className="dash-card">
                        <h2 className="dash-card-title">
                            <Link to={'/dashboard/reports'} className='title-back-link'>
                                <i className="fi fi-rr-arrow-small-left"></i>
                            </Link>
                            Reports for {reportsMonth}/{reportsYear}
                        </h2>
                        <div className="table-responsive mt-3">
                            <table className="table dash-table">
                                <thead>
                                    <tr>
                                        <td>Release</td>
                                        <td>UPC</td>
                                        <td>Track</td>
                                        <td>ISRC</td>
                                        <td>Streams</td>
                                        <td>Net Earnings</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentItems.length > 0 ? (
                                            currentItems.map((report, i) => (
                                                <tr key={`${report.upc}-${report.isrc}-${i}`}>
                                                    <td>{report.releaseTitle}</td>
                                                    <td>{report.upc}</td>
                                                    <td>{report.trackTitle}</td>
                                                    <td>{report.isrc}</td>
                                                    <td>{report.streams.toLocaleString()}</td>
                                                    <td>${report.netEarnings.toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">No reports found for this period.</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        {reports.length > itemsPerPage && (
                            <Pagination currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportsDetails